export const ROUTES = {
    ROOT: "/",
    LOGIN: "/login",
    DASHBOARD: "/dashboard",
    PLAYERS: "/players",
    COMMISSION: "/commission",
    CREATE_PLAYER: "/players/player/:path_player_id?",
    VIEW_PLAYER: "/players/viewPlayer/:path_player_id?",
    USER_HOLDINGS:"/user-holdings"
};


export const moduleHeader = {
    [ROUTES.ROOT]: "",
    [ROUTES.LOGIN]: "Login",
    [ROUTES.DASHBOARD]: "Dashboard",
    [ROUTES.PLAYERS]: "Players",
    [ROUTES.CREATE_PLAYER]: "Create Player",
    [ROUTES.VIEW_PLAYER]: "View Player",
    [ROUTES.COMMISSION]: "Commission",
    [ROUTES.USER_HOLDINGS]: "User Holdings",
};
